import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

// Main Pages
import Landing from './pages/Landing';
import ExploreCalculators from './pages/ExploreCalculators';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';

// Legal Pages
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';

// Calculator Pages - Arithmetic & Number Theory
import TrigCalculator from './pages/TrigCalculator';
import FractionCalculator from './pages/FractionCalculator';
import PrimeCalculator from './pages/PrimeCalculator';
import LcmGcdCalculator from './pages/LcmGcdCalculator';
import ExponentCalculator from './pages/ExponentCalculator';
import ScientificNotationConverter from './pages/ScientificNotationConverter';

// Calculator Pages - Algebra
import LinearEquationSolver from './pages/LinearEquationSolver';
import QuadraticSolver from './pages/QuadraticSolver';
import PolynomialCalculator from './pages/PolynomialCalculator';
import SequencesCalculator from './pages/SequencesCalculator';

// Calculator Pages - Geometry & Trigonometry
import TriangleSolver from './pages/TriangleSolver';
import CircleCalculator from './pages/CircleCalculator';
import PolygonCalculator from './pages/PolygonCalculator';
import Shape3DCalculator from './pages/Shape3DCalculator';
import TrigIdentityCalculator from './pages/TrigIdentityCalculator';

// Calculator Pages - Calculus
import DerivativeCalculator from './pages/DerivativeCalculator';
import IntegralCalculator from './pages/IntegralCalculator';
import LimitCalculator from './pages/LimitCalculator';
import FunctionGrapher from './pages/FunctionGrapher';

import './index.css';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <div className="min-h-screen bg-background flex flex-col">
            <Navbar />

            <main className="flex-1">
              <Routes>
                {/* ================= Main Pages ================= */}
                <Route path="/" element={<Landing />} />
                <Route path="/explore" element={<ExploreCalculators />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/contact" element={<Contact />} />

                {/* ================= Legal Pages ================= */}
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/disclaimer" element={<Disclaimer />} />

                {/* ========== Arithmetic & Number Theory ========== */}
                <Route path="/calculators/fraction" element={<FractionCalculator />} />
                <Route path="/calculators/prime" element={<PrimeCalculator />} />
                <Route path="/calculators/lcm-gcd" element={<LcmGcdCalculator />} />
                <Route path="/calculators/exponent" element={<ExponentCalculator />} />
                <Route path="/calculators/scientific-notation" element={<ScientificNotationConverter />} />

                {/* ================= Algebra ================= */}
                <Route path="/calculators/linear-equation" element={<LinearEquationSolver />} />
                <Route path="/calculators/quadratic-solver" element={<QuadraticSolver />} />
                <Route path="/calculators/polynomial" element={<PolynomialCalculator />} />
                <Route path="/calculators/sequences" element={<SequencesCalculator />} />

                {/* ========= Geometry & Trigonometry ========= */}
                <Route path="/calculators/triangle-solver" element={<TriangleSolver />} />
                <Route path="/calculators/circle" element={<CircleCalculator />} />
                <Route path="/calculators/polygon" element={<PolygonCalculator />} />
                <Route path="/calculators/shape-3d" element={<Shape3DCalculator />} />
                <Route path="/calculators/trig-identity" element={<TrigIdentityCalculator />} />
                <Route path="/calculators/trigonometry" element={<TrigCalculator />} />

                {/* ================= Calculus ================= */}
                <Route path="/calculators/derivative" element={<DerivativeCalculator />} />
                <Route path="/calculators/integral" element={<IntegralCalculator />} />
                <Route path="/calculators/limit" element={<LimitCalculator />} />
                <Route path="/calculators/function-grapher" element={<FunctionGrapher />} />

                {/* Catch-all for undefined routes */}
                <Route path="*" element={<Landing />} />
              </Routes>
            </main>

            <Footer />
            <CookieConsent />
          </div>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
